import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { shortcutsApi } from '../lib/api.js';
import { screenFromPathname } from './company-sections.js';

/// Conta a visita à tela que o endereço aponta.
///
/// Fica na casca da empresa, e não dentro de cada tela: um lugar que conta em vez de oito chances
/// de esquecer. Como a posição virou endereço, saber onde a pessoa está é ler a URL.
///
/// **Não escreve na trilha de auditoria** — de propósito. Auditoria é o que alguém mudou; isto é o
/// que alguém olhou, e são coisas diferentes. Uma trilha que registra leitura de tela vira ruído e
/// afoga o que ela existe para guardar.
export function useScreenVisit(companyKey: string): void {
  const pathname = useLocation({ select: (location) => location.pathname });
  const screen = screenFromPathname(pathname, companyKey);
  /// O que já foi contado nesta montagem. Sem isto, o efeito rodando duas vezes — como o React faz
  /// de propósito em desenvolvimento — contaria duas visitas para uma tela aberta uma vez.
  const counted = useRef<string | null>(null);

  useEffect(() => {
    if (!screen || counted.current === screen) return;
    counted.current = screen;
    void shortcutsApi.recordVisit(screen);
  }, [screen]);
}
